(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DistrictNodalOfficer', DistrictNodalOfficer);

    DistrictNodalOfficer.$inject = ['$resource'];

    function DistrictNodalOfficer ($resource) {
        var resourceUrl =  'api/district-nodal-officers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
